type GoogleMapsUrlParams = {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
  /** 照合用住所（都道府県＋市区町村＋番地。建物名を含めない） */
  matchingAddress: string | null | undefined;
  /** 施設の place_id。勤務地が施設と同じ場所のときだけサーバーが返す */
  googlePlaceId?: string | null;
};

const GOOGLE_MAPS_SEARCH_URL = "https://www.google.com/maps/search/";

/**
 * 勤務地を Google マップで開く URL。開けない場合は null（リンクを出さない）
 *
 * 住所文字列で検索すると候補一覧や同じ住所の別施設が出るため、施設の place_id があれば施設1件を開く。
 * place_id が Google 側で無効になっていたときに備え、予備の検索語には座標（無ければ照合用住所）を付ける。
 * 施設名は候補一覧になりうるため予備の検索語に使わない。
 * place_id が無ければ座標の1か所で開き、座標も無いときだけ照合用住所で検索する（建物名は自由記述で検索を外すため含めない）。
 * モバイルも同じ形式の URL を使う。
 *
 * @see https://developers.google.com/maps/documentation/urls/get-started#search-action
 */
export function buildGoogleMapsUrl({
  latitude,
  longitude,
  matchingAddress,
  googlePlaceId,
}: GoogleMapsUrlParams): string | null {
  const hasCoordinates = latitude != null && longitude != null;
  const query = hasCoordinates
    ? `${latitude},${longitude}`
    : matchingAddress?.trim();
  if (!query) return null;

  const params = new URLSearchParams({ api: "1", query });
  if (googlePlaceId) params.set("query_place_id", googlePlaceId);
  return `${GOOGLE_MAPS_SEARCH_URL}?${params.toString()}`;
}
